import { useLocation } from 'react-router-dom';

export function useFirstOpenedPage() {
    const location = useLocation();
    const hasPrevRoute = location.key !== 'default';

    return !hasPrevRoute && !Boolean(location.search);
}
